import { pageSearchScore } from './page-search.ts'

/** Suggested pages stay below even the weakest keyword match. */
export const SUGGESTED = 0.02
/** Commands stay below suggested pages and above merchants. */
export const ACTION = 0.01
/** Merchants stay below commands. */
export const MERCHANT = 0.001
/** The Ask AI row stays below every merchant, so a typed name still opens it first. */
export const ASK_AI = MERCHANT * 0.9
/** The full search link stays below every result. */
export const SEE_ALL = MERCHANT / 2

/** Break page ties by source order without changing hidden rows or blank queries. */
export function tiedPageScore(
  value: string,
  search: string,
  index: number
): number {
  const score = pageSearchScore(value, search)
  if (score === 0 || search.trim() === '') return score
  // The largest page offset stays far below the gap between distinct page scores.
  return score - index * 1e-9
}

/** Preserve Jev's rank within the suggested band. */
export function suggestedScore(rank: number): number {
  return SUGGESTED - rank * 1e-9
}
